import axios from 'axios';

const axiosClient = axios.create({
    baseURL: process.env.REACT_APP_BACKEND_PORTAL_URL   
});


// Request interceptor for API calls
axiosClient.interceptors.request.use(
  async config => {
    const access = localStorage.getItem('access');
    const token = localStorage.getItem('token');
    config.headers = { 
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',   
      'Authorization': access,
      'X-jwt': token,

    }
    return config;
  },
  error => {
    Promise.reject(error)
});

/*
// Response interceptor for API calls
axiosClient.interceptors.response.use((response) => {
  return response
}, async function (error) {
  const originalRequest = error.config;
  if (error.response.status === 403 && !originalRequest._retry) {
    originalRequest._retry = true;
    const access_token = await refreshAccessToken();            
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
    return axiosApiInstance(originalRequest);
  }
  return Promise.reject(error);
});
*/
export default axiosClient;
